import { Helmet } from 'react-helmet-async';
import React, { useEffect } from 'react';
import { Container, Typography } from '@mui/material';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { notification } from 'antd';
import TabContext from '@mui/lab/TabContext';
import { useTranslation } from 'react-i18next';
import { getToken } from '../utils/common';
import Procedure from './component/procedures';

export default function Information() {
  const [valuest, setValuest] = React.useState('1');
  const { t } = useTranslation();
  const url1 = `${globalThis.REACT_APP_API_PURE}procedure/list`;

  const fetchInfo1 = async () => {
    try {
      const res = await fetch(url1, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });
      await res.json();
    } catch (error) {
      notification.error({
        message: 'Error',
        description: error,
        placement: 'top',
        duration: 5,
      });
    }
  };

  useEffect(() => {
    fetchInfo1();
  }, []);

  const handleChangeTab = (event, newValuest) => {
    setValuest(newValuest);
  };

  return (
    <>
      <Helmet>
        <title> Information | SMARTSHIELD </title>
      </Helmet>
      <Container>
        <Typography component="h1" variant="h4" sx={{ mb: 5 }}>
          {t('Ingpomase.1')}
        </Typography>
        <div>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={valuest}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChangeTab} aria-label="lab API tabs example">
                  <Tab label={t('Procedures.1')} value="1" />
                </TabList>
              </Box>
              <TabPanel value="1">
                <Procedure />
              </TabPanel>
            </TabContext>
          </Box>
        </div>
      </Container>
    </>
  );
}
